var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "editor_choice"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_668_644",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.666748,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_668_644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "editor_choice_2",
    d: "M13.1668 46V28.85L6.76685 18.5L15.7168 4H33.6168L42.5668 18.5L36.1668 28.85V46L24.6668 42.15L13.1668 46ZM16.1668 41.8L24.6668 39.05L33.1668 41.8V33H16.1668V41.8ZM17.3668 7L10.2668 18.5L17.3668 30H31.9668L39.0668 18.5L31.9668 7H17.3668ZM22.5668 25.95L16.1668 19.6L18.3168 17.45L22.5668 21.7L31.0168 13.2L33.1668 15.3L22.5668 25.95Z",
    fill: "#5663F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorChoice);
export default __webpack_public_path__ + "static/media/editor_choice.3e6273a86bccf92c5eb1187275c1f1be.svg";
export { ForwardRef as ReactComponent };